import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatColorTextIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_color_text"}/>
}
